const { filename_part: filenamePart } = window.FCGON
const meta = document.querySelector("meta[name=csrf-token]")
const token = meta ? meta.content : ""

const periodTypes = {
  p: "p,t",
  t: "t,h",
  h: "t,h",
}
function getURL(initialMode) {
  const base = `/breaks/${filenamePart}/forecasts/data?&parts=all`
  if (initialMode === "p") return `${base}&period_types=${periodTypes[initialMode]}`

  return `${base}&period_types=${periodTypes[initialMode]}&forecast_duration=48h`
}

function fetchData(initialMode) {
  const url = getURL(initialMode)

  return fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": token,
    },
  }).then((response) => {
    if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`)

    return response.json()
  })
}

export default fetchData
